<template>
  <div style="height: inherit">
    <v-snackbar class="pa-0" light timeout="-1" v-model="alertShow" width="fit-content" top centered>
      <v-alert
          v-model="alertShow"
          dismissible
          :icon="alertSuccess ? 'check_circle' : 'cancel'"
          class="mb-0 pa-1"
          :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
          light
          close-icon="close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
    <v-card class="vip-card justify-center">
      <v-row no-gutters justify="center" class="betting-pass-header-details hidden-md-and-up" :class="$vuetify.breakpoint.smAndUp ? 'mx-6 mt-2 mb-2' : 'mx-2 mt-8 mb-8'">
        <v-col cols="12" md="9" lg="9">
          <div class="ipl-betting-pass-banner-container">
            <img v-if="$vuetify.breakpoint.mdAndUp" src="/static/image/ipl-betting-pass/left-asset.png" class="betting-pass-tiger hidden-sm-and-down" />
            <div class="betting-pass-banner" :class="currentCurrency == 'PKR' ? 'betting-pass-banner-psl': ''">
              <div class="betting-pass-content">
                <h3 class="title-1">{{ $t(`footer.babu88IPL`) }}</h3>
                <span class="content hidden-sm-and-down">{{ $t(`footer.babu88IPL_sub`) }}</span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3" lg="3" class="betting-pass-level-container">
          <img src="/static/image/ipl-betting-pass/right-asset.png" class="betting-pass-treasure  hidden-sm-and-down" />
          <v-card class="vip-progress-card" elevation="0" v-if="isLoggedIn" :class="isLoggedIn ? 'logged-in' : ''">
            <v-row no-gutters align="end" class="px-3 pt-4">
              <v-col cols="12">
                <span class="vip-progress-text mobile ">{{ $t(`label.bettingPassProgress`) }}</span>
              </v-col>
              <v-col class="mobile-logged-details">
                <v-row no-gutters justify="center" class="mobile-logged-level">
                  <v-col cols="12" class="text-center vip-level">
                    <span class="white--text font-weight-bold">{{ currentLvlCode }}</span>
                  </v-col>
                </v-row>
                <v-row no-gutters class="progress-bar-details">
                  <v-col cols="12">
                    <span class="vip-progress-text hidden-sm-and-down ">{{ $t(`label.bettingPassProgress`) }}</span>
                  </v-col>
                  <v-col cols="12">
                    <div class="vip-progress-bar-text">
                      <span v-if="iplVipProgress.member_progress_type == 2">{{ iplVipProgress.current_deposit_progress }} / {{ iplVipProgress.required_deposit_amount }}</span>
                      <span v-if="iplVipProgress.member_progress_type == 3">{{ iplVipProgress.current_rollover_progress }} / {{ iplVipProgress.required_account_rollover }}</span>
                    </div>
                    <v-row class="mobile-gutter">
                      <v-col cols="12">
                        <v-progress-linear :height="$vuetify.breakpoint.smAndDown ? 13 : 10" class="vip-progress-bar" :value="vipProgressPercentage"></v-progress-linear>
                      </v-col>
                    </v-row>
                    <div class="progress-node-desc">
                      <span class="vip-current-level-text">{{ iplVipProgress.current_level_name }}</span>
                      <span class="vip-next-level-text">{{ iplVipProgress.next_level_name }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row justify="center" no-gutters class="px-3 pt-4 deposit-desc-btn">
              <v-col class="clos">
                <span class="vip-progress-text">{{ $t(`label.bettingPassDepositNow`) }}</span>
              </v-col>
              <v-col cols="12">
                <app-button class="white--text dialog-button" custom-class="betting-pass-deposit-button" :action="goToDepositPage" :title="$t(`label.depositNow`)"></app-button>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="vip-progress-card" elevation="0" style="" v-else>
            <v-row no-gutters align="end" class="px-3 pt-3">
              <v-col>
                <v-row no-gutters justify="center">
                  <v-col cols="12" class="my-2">
                    <span class="white--text betting-pass-login-text">{{ $t(`label.bettingPassLogin`) }}</span>
                  </v-col>
                </v-row>
                <v-row no-gutters justify="center">
                  <v-col class="text-center" cols="12">
                    <app-button :customClass="' subtitle-1 full-width pa-2 theme-button betting-pass-register-button'" :action="this.goToRegisterPage" :title="$t(`label.register`)"></app-button>
                  </v-col>
                  <v-col cols="12" class="mb-6 text-center">
                    <v-btn
                        height="auto"
                        @click="this.goToLoginPage"
                        class="buttonPrimary primary-button pa-1  full-width"
                        :class="$vuetify.breakpoint.xsOnly ? 'betting-pass-login-button' : 'betting-pass-login-button'"
                    >
                      {{ $t(`button.login`) }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center" class="hidden-sm-and-down" :class="$vuetify.breakpoint.smAndUp ? 'mt-16 mb-8' : 'mx-2 mt-8 mb-8'">
        <v-col cols="12" md="9" lg="9">
          <div class="ipl-betting-pass-banner-container">
            <img src="/static/image/ipl-betting-pass/left-asset.png" class="betting-pass-tiger" />
            <div class="betting-pass-banner" :class="currentCurrency == 'PKR' ? 'betting-pass-banner-psl': ''">
              <div class="betting-pass-content">
                <h3 class="title-1">{{ $t(`footer.babu88IPL`) }}</h3>
                <span class="content">{{ $t(`footer.babu88IPL_sub`) }}</span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3" lg="3" class="betting-pass-level-container">
          <img src="/static/image/ipl-betting-pass/right-asset.png" class="betting-pass-treasure" />
          <v-card class="vip-progress-card" elevation="0" v-if="isLoggedIn">
            <v-row no-gutters align="end" class="px-3 pt-4">
              <v-col>
                <v-row no-gutters justify="center">
                  <v-col cols="12" class="text-center vip-level">
                    <span class="white--text font-weight-bold">{{ currentLvlCode }}</span>
                  </v-col>
                </v-row>
                <v-row no-gutters class="pt-6">
                  <v-col cols="12">
                    <span class="vip-progress-text">{{ $t(`label.bettingPassProgress`) }}</span>
                  </v-col>
                  <v-col cols="12">
                    <div class="vip-progress-bar-text">
                      <span v-if="iplVipProgress.member_progress_type == 2">{{ iplVipProgress.current_deposit_progress }} / {{ iplVipProgress.required_deposit_amount }}</span>
                      <span v-if="iplVipProgress.member_progress_type == 3">{{ iplVipProgress.current_rollover_progress }} / {{ iplVipProgress.required_account_rollover }}</span>
                    </div>
                    <v-progress-linear :height="$vuetify.breakpoint.xsOnly ? 35 : 5" class="vip-progress-bar" :value="vipProgressPercentage"></v-progress-linear>
                    <div>
                      <span class="vip-current-level-text">{{ iplVipProgress.current_level_name }}</span>
                      <span class="vip-next-level-text">{{ iplVipProgress.next_level_name }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row justify="center" no-gutters class="px-3 pt-6">
              <v-col class="12">
                <span class="vip-progress-text">{{ $t(`label.bettingPassDepositNow`) }}</span>
              </v-col>
              <v-col cols="12">
                <app-button class="white--text dialog-button betting-pass-deposit-button" style="background-color: #0080f6!important;" :action="goToDepositPage" :title="$t(`label.depositNow`)"></app-button>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="vip-progress-card" elevation="0" style="align-content: center;" v-else>
            <v-row no-gutters align="end" class="px-3 pt-3">
              <v-col>
                <v-row no-gutters justify="center">
                  <v-col cols="12" class="my-2">
                    <span class="white--text betting-pass-login-text">{{ $t(`label.bettingPassLogin`) }}</span>
                  </v-col>
                </v-row>
                <v-row no-gutters justify="center">
                  <v-col class="text-center" cols="12">
                    <app-button
                        :customClass="'subtitle-1 full-width pa-2 theme-button betting-pass-register-button'"
                        :action="this.goToRegisterPage"
                        :title="$t(`label.register`)"
                    ></app-button>
                  </v-col>
                  <v-col cols="12" class="mb-6 text-center">
                    <v-btn
                        height="auto"
                        @click="this.goToLoginPage"
                        color="#ffce01"
                        class="primary-button pa-1 black--text full-width"
                        :class="$vuetify.breakpoint.xsOnly ? 'vip-mobile-login-button' : 'betting-pass-login-button'"
                    >
                      {{ $t(`button.login`) }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <!--      desktop+mobile responsive view-->
      <div class="" :class="$vuetify.breakpoint.mdAndUp ? 'mt-16 mb-8' : 'mx-2 mt-8 mb-8'">
        <v-card style="background: transparent !important">
          <v-card class="betting-pass-summary-table" elevation="0">
            <v-row align="center" no-gutters class="betting-pass-prizes-row" id="betting-pass-prizes-row">
              <v-col md="2" lg="2" v-for="(reward, index) in currrentVipSummary" :key="index" class="mobile-prize-card">
                <div class="betting-pass-reward-container" :id="`prize_` + (index + 1)">
                  <img class="betting-pass-reward-img" :src="getDisplayIcon(reward)" />
                  <span class="betting-pass-reward-level-text">{{ reward.level }}</span>
                  <v-divider class="betting-pass-reward-divider"></v-divider>
                  <span class="betting-pass-reward-text" v-if="reward.reward_type == 'COINS'">
                    {{ $t(`label.free`) + ' ' + currencySymbolMapp(currentCurrency) + reward.text }}
                  </span>
                  <span class="betting-pass-reward-text" v-else-if="reward.reward_type == 'BONUS'">
                    {{ reward.text + ' ' + $t(`label.bonus`) }}
                  </span>
                  <span class="betting-pass-reward-text" v-else-if="reward.reward_type == 'GIFT'">
                    {{ reward.text }}
                  </span>
                </div>
                <v-col class="text-center" cols="12">
                  <app-button
                      custom-class="buttonPrimary theme-button theme--light betting-pass-reward-button"
                      :disabled="iplVipProgress.has_pending_claim && currentLvlCode == reward.level ? false : true"
                      :action="claimVipProgress"
                      :title="$t(`button.claimVip`)"
                  ></app-button>
                </v-col>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </div>

      <v-row
          no-gutters
          style="
    padding-bottom: 70px;
"
      >
        <v-col cols="12" class="text-center mb-md-6" v-if="pagination.totalPage > 1">
          <v-pagination
              dark
              circle
              class="vip_summary_pagination"
              v-model="pagination.currentPage"
              :length="pagination.totalPage"
              @input="changePage"
              :next-icon="'arrow_forward_ios'"
              :prev-icon="'arrow_back_ios'"
              :total-visible="pagination.paginationPageLimit"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { BONUS_LIST, VIP_BONUS_CHECK, VIP_BONUS_RESET, IPL_VIP_CLAIM_REWARD, VIP_RESET_CLAIM, IPL_VIP_REWARDS_SUMMARY } from '../../store/bonus.module'
import { MEMBER_GET_IPL_VIP_PROGRESS } from '../../store/member.module'
import { VipClaimType } from '../../constants/enums'
import { ROUTE_NAME } from '../../constants/route.constants'
import { locale, errorCodeHelper, uiHelper } from '@/util'
import currencySymbolMapp from 'currency-symbol-map'
import { SHARED } from '@/constants/constants'
import AppLoginEmbedded from '@/components/member/loginEmbedded.vue'

export default {
  name: 'iplVipPage',
  metaInfo: {
    title: `${locale.getMessage('meta.vipProfile_title')}`,
    titleTemplate: `%s | ${uiHelper.getHost()}`
  },
  data: () => ({
    bonusPercentage: '',
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    pagination: {
      currentPage: 1,
      totalPage: 1,
      paginationPageLimit: 10
    },
    currrentVipSummary: [],
    searchCriteria: {
      pageNumber: 1,
      pageSize: 6,
      mobilePageSize: 10
    },
    currentCurrency: uiHelper.getCurrency(),
    language: uiHelper.getLanguage(),
    currencySymbolMapp: currencySymbolMapp,
    alertShow: false,
    alertSuccess: true,
    alertMessage: '',
  }),
  components: {
    AppLoginEmbedded
  },
  computed: {
    isApplicable() {
      return this.$store.state.bonus.vipBonusCheckResult.data.available
    },
    applyComplete() {
      return this.$store.state.bonus.vipBonusApplyResult.complete
    },
    iplVipProgress() {
      return this.$store.state.member.iplVipProgress
    },
    vipClaimComplete() {
      return this.$store.state.bonus.vipProgressClaimResult.complete
    },
    vipRewardsSummaryData() {
      return this.$store.state.bonus.iplVIPRewardsSummary
    },
    vipClaimType() {
      switch (this.iplVipProgress.member_progress_type) {
        case VipClaimType.BOTH:
          return 'Rollover and Deposit'
        case VipClaimType.DEPOSIT_ONLY:
          return 'Deposit Only'
        case VipClaimType.ROLLOVER_ONLY:
          return 'Rollover Only'
      }
    },
    vipProgressPercentage() {
      if (this.iplVipProgress.member_progress_type == 2) {
        return (this.iplVipProgress.current_deposit_progress / this.iplVipProgress.required_deposit_amount) * 100
      } else if (this.iplVipProgress.member_progress_type == 3) {
        return (this.iplVipProgress.current_rollover_progress / this.iplVipProgress.required_account_rollover) * 100
      }
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    currentLvlCode() {
      return this.iplVipProgress.current_level_name.split(' ')[1]
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    }
  },
  watch: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    applyComplete() {
      if (this.$store.state.bonus.vipBonusApplyResult.success) {
        window.alert('VIP Bonus apply status: ' + this.$store.state.bonus.vipBonusApplyResult.success)
        this.$store.dispatch(`${VIP_BONUS_RESET}`)
        this.getVipApplicability()
      }
    },
    vipClaimComplete() {
      if (this.$store.state.bonus.vipProgressClaimResult.complete) {
        this.showVipClaimProgress(this.$store.state.bonus.vipProgressClaimResult)
      }
    },
    vipRewardsSummaryData() {
      this.renderPage()
      // this.changePage(1)
    },
    alertShow() {
      if (!this.alertShow) {
        this.alertSuccess = ''
        this.alertMessage = ''
      }
    }
  },
  created() {
    this.metaTag()
    this.getVipApplicability()
    this.getVipProgress()
    this.getVipRewardsSummary()
    this.getAvailableBonus()
  },
  methods: {
    metaTag() {
      const currentUrl = window.location.href
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      const path = window.location.pathname
      const cleanPath = path.replace(/\/(en-BD|bn-BD|en-IN|hi-IN|en-NP|ne-NP|en-PK|ur-PK)/i, '')
      const Links = `https://${domain}${cleanPath}`
      const Linksen = `https://${domain}/en-BD${cleanPath}`
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`
      const Linksenin = `https://${domain}/en-IN${cleanPath}`
      const Linksenhi = `https://${domain}/hi-IN${cleanPath}`
      const Linksenennp = `https://${domain}/en-NP${cleanPath}`
      const Linksennenp = `https://${domain}/ne-NP${cleanPath}`
      const Linksenpk = `https://${domain}/en-PK${cleanPath}`
      const Linksenur = `https://${domain}/ur-PK${cleanPath}`

      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
      uiHelper.setHreflangLinksenin(Linksenin)
      uiHelper.setHreflangLinkshi(Linksenhi)
      uiHelper.setHreflangLinksennp(Linksenennp)
      uiHelper.setHreflangLinksnenp(Linksennenp)
      uiHelper.setHreflangLinksenpk(Linksenpk)
      uiHelper.setHreflangLinksur(Linksenur)
    },
    getAvailableBonus() {
      if (this.isLoggedIn) {
        this.$store.dispatch(`${BONUS_LIST}`)
      }
    },
    getVipApplicability() {
      if (this.isLoggedIn) {
        this.$store.dispatch(`${VIP_BONUS_CHECK}`)
      }
    },
    getVipProgress() {
      if (this.isLoggedIn) {
        this.$store.dispatch(MEMBER_GET_IPL_VIP_PROGRESS)
      }
    },
    getVipRewardsSummary() {
      this.$store.dispatch(IPL_VIP_REWARDS_SUMMARY)
    },
    renderPage() {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.pagination.totalPage = Math.ceil(this.vipRewardsSummaryData.length / this.searchCriteria.mobilePageSize)
      } else {
        this.pagination.totalPage = Math.ceil(this.vipRewardsSummaryData.length / this.searchCriteria.pageSize)
      }
      this.searchCriteria.pageNumber = 1
      this.changePage(1)
    },
    changePage(targetPage) {
      this.searchCriteria.pageNumber = targetPage
      if (this.$vuetify.breakpoint.xsOnly) {
        this.currrentVipSummary = this.vipRewardsSummaryData.slice(
            (this.searchCriteria.pageNumber - 1) * this.searchCriteria.mobilePageSize,
            this.searchCriteria.pageNumber * this.searchCriteria.mobilePageSize
        )
      } else {
        this.currrentVipSummary = this.vipRewardsSummaryData.slice((this.searchCriteria.pageNumber - 1) * this.searchCriteria.pageSize, this.searchCriteria.pageNumber * this.searchCriteria.pageSize)
      }
    },
    applyVipBonus() {
      const selectedBonusId = this.$store.state.bonus.vipBonusCheckResult.data.bonusId
      this.$router.push({
        name: ROUTE_NAME.DEPOSIT,
        params: {
          bonusId: selectedBonusId
        }
      })
    },
    claimVipProgress() {
      this.getVipApplicability()
      if (this.isApplicable) {
        this.reminderDialog()
      } else {
        this.dispatchVipProgress()
      }
    },
    dispatchVipProgress() {
      this.$store.dispatch(IPL_VIP_CLAIM_REWARD)
    },
    showVipClaimProgress(result) {
      if (result.success) {
        this.openAlert(true, locale.getMessage(`message.vipBonusSuccess`))
      } else {
        this.openAlert(false, locale.getMessage(`message.vipBonusFailed`))
      }
      this.$store.dispatch(VIP_RESET_CLAIM)
      this.getVipProgress()
      this.getVipApplicability()
    },
    getDisplayIcon(reward) {
      switch (reward.reward_type) {
        case 'COINS':
          return this.getCoinPath()
        case 'GIFT':
          return reward.reward_gift ? reward.reward_gift.imgUrl : ''
        case 'BONUS':
          return this.getGiftPath()
      }
    },
    // hard code asset path
    getCoinPath() {
      return 'https://jiliwin.9terawolf.com/cms/babuVip/vip-reward-icon.png'
    },
    getGiftPath() {
      return 'https://jiliwin.9terawolf.com/cms/babuVip/vip-reward-gift.png'
    },
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    },
    openLoginDialog() {
      this.$parent.openLoginDialog()
    },
    openRegisterDialog() {
      this.$parent.openRegisterDialog()
    },
    goToRegisterPage() {
      this.$router.push({
        name: ROUTE_NAME.REGISTER,
        params: { lang: this.$route.params.lang }
      })
    },
    goToLoginPage() {
      this.$router.push({
        name: ROUTE_NAME.LOGIN,
        params: { lang: this.$route.params.lang }
      })
    },
    goToDepositPage() {
      this.$router.push({
        name: ROUTE_NAME.DEPOSIT,
        params: { lang: this.$route.params.lang }
      })
    },
    reminderDialog() {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.Confirmation`)
      dialog.message.push(locale.getMessage(`message.vipSpecialBonusRedeemReminder`))
      dialog.button.push({
        title: locale.getMessage(`label.ok`),
        action: () => this.dispatchVipProgress()
      })
      dialog.button.push({
        title: locale.getMessage(`button.cancel`),
        action: () => this.closePageDialog()
      })
      this.openPageDialog(dialog)
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closePageDialog() {
      this.$eventHub.$emit('close-page-dialog', true)
    }
  }
}
</script>

<style lang="scss">
.vip-card {
  .mobile-lvl-card {
    background-color: #000000;
    box-shadow: 0px 0px 4px var(--v-newMobilePrimary-base) !important;
    height: 52px;
    width: 52px;
    max-width: 52px;
    color: #ffffff;
    text-align: center;
    padding-top: 2px;
    font-size: 12px;
    .lvl-title {
      font-size: 26px;
      padding: unset;
    }
  }
  .mobile-progress-header-div {
    display: flex;
    color: #ffffff;
    margin-left: 30px;
    margin-right: 20px;
    gap: 0px 10px;
    gap: 0px 10px;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .v-timeline:after {
    bottom: 0;
    content: '';
    height: 100%;
    position: absolute;
    top: 0;
    width: 2px;
    left: calc(45% - 1px);
    background: #474747;
  }
  .resetInclineStyle {
  }
  .fulfilled {
    box-shadow: 0px 0px 4px #ffce01 !important;
  }

  .fulfilled-claimBtn {
    background-color: var(--v-newMobilePrimary-base);
    color: #000000;
    opacity: 0.5;
  }

  .giftPrize-size {
    height: 4rem !important;
    margin-top: -22px;
  }

  .currentLvl-claimBtn {
    opacity: unset !important;
  }
  .claimable-btn {
    opacity: unset !important;
  }

  .mobile-vip-header {
    height: 100px;
    border-bottom: 2px solid var(--v-newMobilePrimary-base);
    //opacity: .5;
  }
  .v-timeline {
    height: max-content;
  }
  .theme--light.v-timeline::before {
    background-color: var(--v-newMobilePrimary-base);
    left: calc(45% - 1px) !important;
  }
  .v-timeline-item {
    padding-bottom: 50px !important;
  }
  .v-timeline-item__dot {
    background: transparent !important;
  }
  .v-timeline-item__dot {
    width: 200px;
    .v-timeline-item__inner-dot {
      width: inherit;
      margin: 4px 0 0 4px;
      .prizename-card {
        background-color: #000000;
        color: #ffffff;
        width: inherit;
        height: 60px;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        .prizename-span {
        }
      }
    }
  }
  .prizeImg.v-card {
    width: 65px;
    height: 60px;
    background-color: #000000;
    box-shadow: 0px 2px 4px 0px #00000040 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--v-newMobilePrimary-base);
    flex-direction: column;
    border-radius: 8px;
    .prizeIndex-span {
      width: 100%;
      text-align: left;
      margin-left: 8px;
    }
  }
}

.claim-btn {
  color: #9b9b9b;
  height: 60px;
  width: 113px;
  background-color: #474747;
  box-shadow: 0px 2px 4px 0px #00000040;
  border-radius: 8px;
  .v-card__text {
    padding: unset;
  }
  display: flex;
  align-items: center;
  justify-content: center;
}

.vip-timeline-wrapper {
  display: flex;
  justify-content: center;
  height: 57vh;
  overflow-y: scroll;
  //margin: 15px 50px 15px 50px;
}
.profile-alert-success {
  .v-icon {
    color: #25b34b;
  }
}

.profile-alert-failed {
  .v-icon {
    color: #dc2d2d;
  }
}

.vip-summary-container {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  max-width: 100vw;

  .border-top-left-radius {
    border-top-left-radius: 10px !important;
  }

  .border-top-right-radius {
    border-top-right-radius: 10px !important;
  }

  .border-bottom-left-radius {
    border-bottom-left-radius: 10px !important;
  }

  .border-bottom-right-radius {
    border-bottom-right-radius: 10px !important;
  }
}

.vip-card {
  background-color: transparent !important;
  .betting-pass-header-details {
    @media screen and (max-width: 959px) {
      gap: 1.5rem 0;
      flex-direction: column;
      margin: 0 24px !important;
    }
  }
  .vip-progress-card {
    width: 272px;
    height: 100%;
    max-height: 300px;
    background-color: #1c1c1c;
    border: 1px solid white;
    border-radius: 20px;

    &.logged-in {
      display: flex;
      flex-direction: column;
    }

    .progress-bar-details {
      padding-top: 24px;
    }

    .vip-progress-status-title {
      background-image: linear-gradient(to left, #fddd04, #fdb504);
      padding: 1px 4px;
    }

    .betting-pass-register-button {
      width: 100% !important;
      height: 40px !important;
      margin: 4px 0 !important;
      color: white !important;
      background-color: #0080f6;
      @media screen and (max-width: 959px) {
        height: 35px !important;
      }
    }

    .betting-pass-login-button {
      width: 100% !important;
      height: 40px !important;
      margin: 4px 0 !important;
    }

    .betting-pass-deposit-button {
      width: 100% !important;
      height: 40px !important;
      margin: 4px 0 !important;
      background-color: #0080f6;
      border-radius: 12px;
    }
  }

  .icon-size {
    height: 2em;
  }

  .vip-process-bar-icon {
    border: 10px solid #262626;
    z-index: 1;

    img {
      padding: 6px;
    }
  }

  .vip-progress-bar {
    background-color: #acacac !important;
    border-radius: 20px;

    .v-progress-linear__background {
      background-color: #acacac !important;
      border-color: #acacac !important;
      opacity: 1 !important;
    }

    .v-progress-linear__determinate {
      background-image: linear-gradient(to left, #fddd04, #fdb504) !important;
    }
  }

  .betting-pass-summary-table {
    background: transparent;

    .betting-pass-reward-container {
      display: flex;
      flex-direction: column;
      border-radius: 12px;
      margin: 24px 8px 0;
      color: white;
      justify-content: space-around;
      background-color: #000000a6;

      @media screen and (max-width: 959px) {
        height: auto;
      }
      @media screen and (min-width: 960px) and (max-width: 1300px) {
        height: 115px;
      }

      @media screen and (min-width: 1301px) and (max-width: 1999px) {
        height: 180px;
      }

      @media screen and (min-width: 2000px) and (max-width: 2500px) {
        height: 250px;
      }
      .betting-pass-reward-img {
        width: 68%;
        align-self: center;
        margin-top: -24px;
        @media screen and (max-width: 599px) {
          height: 75px;
        }

        @media screen and (min-width: 600px) and (max-width: 959px) {
          width: auto;
          height: 130px;
        }
      }

      .betting-pass-reward-level-text {
        font-size: 22px;
        text-align: end;
        margin-top: -16px;
        margin-right: 12px;
      }

      .betting-pass-reward-divider {
        height: 1px;
        background-color: #575757;
      }

      .betting-pass-reward-text {
        height: 36px;
        font-size: 14px;
        text-align: center;
        align-content: center;
        @media screen and (min-width: 960px) {
          height: 41px;
        }
      }
    }

    .betting-pass-reward-button {
      width: 100% !important;
      height: 40px !important;
    }
  }

  .vip-summary-table {
    background-color: #262626;
    border-radius: 20px 20px 0px 0px !important;

    .content {
      padding: 12px;
    }
  }

  .vip-summary-table-content {
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 0px 0px 20px 20px !important;

    .content {
      padding: 12px;
    }
  }

  .vip-summary-table-mobile {
    background-color: #262626;
    border-radius: 0px;
    padding: 4px;

    .content {
      padding: 4px;
    }
  }

  .vip-summary-table-content-mobile {
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 0px;
    padding: 8px 4px;

    .content {
      padding: 4px;
    }
  }

  .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: #acacac !important;
    color: rgba(0, 0, 0, 0.12) !important;
  }
}

.vip_summary_pagination .v-pagination {
  li {
    border: none !important;

    button {
      border: none !important;
      font-size: 12px;
    }
  }

  .v-pagination__more {
    color: var(--v-newMobilePrimary-base);
  }
}

.selected-level {
  background-color: #0c2aab !important;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.container {
  position: relative;
  text-align: center;
}

.betting-pass-login-text {
  font-size: 15px !important;
}

.embedded-register-button {
  width: 120px !important;
  padding: 4px !important;
}

.embedded-login-button {
  width: 110px !important;
}

.betting-pass-register-button {
  width: 100% !important;
  height: 40px !important;
  margin: 4px 0 !important;
  color: white !important;
  background-color: #0080f6;
}

.betting-pass-login-button {
  width: 100% !important;
  height: 40px !important;
  margin: 4px 0 !important;
}

.betting-pass-deposit-button {
  width: 100% !important;
  height: 40px !important;
  margin: 4px 0 !important;
  color: white !important;
  background-color: #0080f6;
}

.ipl-betting-pass-banner-container {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 300px;
  max-height: 320px;
  position: relative;

  @media screen and (max-width: 959px) {
    min-height: 220px !important;
    max-height: 220px !important;
  }

  .betting-pass-tiger {
    width: 22%;
    position: absolute;
    left: -48px;
    bottom: -18%;

    @media screen and (max-width: 1800px) {
      bottom: -6%;
    }

    @media screen and (max-width: 1300px) {
      left: -13%;
      bottom: -6%;
    }
  }

  .betting-pass-banner {
    width: 85%;
    height: 100%;
    max-width: 930px;
    max-height: 320px;
    margin-right: 20px;
    padding: 20px 16px;
    right: 0;
    position: absolute;
    background-image: url('/static/image/ipl-betting-pass/banner.jpg');
    background-size: cover;
    background-position-x: right;
    border-radius: 20px;

    @media screen and (max-width: 959px) {
      width: 100% !important;
      margin-right: unset !important;
      max-height: 220px;
      display: flex;

      .betting-pass-content {
        width: auto !important;
      }
    }

    @media screen and (max-width: 1300px) {
      align-content: center;
      width: 93%;
      height: 300px;
    }

    .betting-pass-content {
      width: 500px;
      span {
        display: flex;
        color: white;
      }

      .title-1 {
        font-size: 30px;
        font-weight: bold;
        color: white !important;

        @media screen and (max-width: 1300px) {
          font-size: 25px;
        }
      }

      .title-2 {
        font-size: 22px;
        font-weight: bold;

        @media screen and (max-width: 1300px) {
          font-size: 19px;
        }
      }

      .content {
        font-size: 14px;

        @media screen and (max-width: 1300px) {
          font-size: 13px;
        }
      }
    }
  }

  .betting-pass-banner-psl {
    background-image: url('/static/image/ipl-betting-pass/banner.jpg') !important;
  }
}

.vip-level {
  height: 68px;
  font-size: 30px;
  align-content: center;
  background-image: url('/static/image/betting-pass/vip-level-bg.png');
  background-position: center;
}

.vip-progress-text {
  display: flex;
  color: white;
  font-size: 12px;
}

.vip-progress-bar-text {
  color: white;
  font-size: 12px;
  float: right;
}

.vip-current-level-text {
  color: white;
  font-size: 12px;
}

.vip-next-level-text {
  color: white;
  font-size: 12px;
  float: right;
}

.betting-pass-level-container {
  position: relative;
}

.betting-pass-treasure {
  width: 180px;
  position: absolute;
  z-index: 2;
  right: -38px;
  bottom: -24%;

  @media screen and (max-width: 1800px) {
    right: -60px;
  }

  @media screen and (max-width: 1700px) {
    right: -80px;
  }

  @media screen and (max-width: 1500px) {
    right: -120px;
  }
}

@media (max-width: 1024px) {
  .vip-card {
    font-size: 13px;
  }
}

@media (max-width: 959px) {
  .betting-pass-prizes-row {
    flex-wrap: nowrap;
    overflow-x: auto;
    .mobile-prize-card {
      min-width: 25dvw;
    }
  }

  .vip-progress-card {
    width: 100% !important;

    .deposit-desc-btn {
      padding-bottom: 8px;
    }

    .mobile-logged-details {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: left;
      .mobile-logged-level {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%;
      }

      .progress-bar-details {
        padding-top: unset !important;
      }

      .mobile-gutter {
        margin: 0 !important;
        width: 100%;
      }

      .progress-node-desc {
        padding-top: 8px;
      }
    }
  }
  .theme--light.v-pagination .v-pagination__navigation {
    background-color: transparent !important;
    color: black !important;
  }
  .theme--dark.v-pagination .v-pagination__navigation {
    background-color: transparent !important;
    color: black !important;
  }
  .mobile-vip-header {
    margin-top: unset !important;
  }
  .vip-card {
    height: inherit;
    .icon-size {
      height: 44px;
      //margin-bottom:30px;
    }
    .v-timeline:before {
      height: 95% !important;
      /*start yellow line after the first level box*/
      top: 30px !important;
    }
    .v-timeline-item__body {
      padding-left: 50px;
    }
    .v-timeline-item__opposite {
      padding-right: 50px;
    }

    .vip_summary_pagination .v-pagination li button {
      font-size: 1.2rem;
      height: 32px;
    }
  }

  .vip-card {
    background-color: #333 !important;
  }
  .theme--dark.v-pagination .v-pagination__navigation {
    background-color: transparent;
  }
  .vip-mobile-login-button {
    width: 120px !important;
    height: 30px !important;
    font-size: 12px !important;
  }
  .vip-mobile-register-button {
    width: 120px !important;
  }

  //  mobile layout
  .v-pagination {
    margin: 15px 0px;
    li {
      button {
        border-radius: 50% !important;
        min-height: 31px !important;
        min-width: 31px !important;
        margin-right: 10px;
      }
    }
  }
  .theme--dark.v-pagination.v-pagination__item.v-pagination__item--active {
    background-color: #474747 !important;
    color: var(--v-newMobilePrimary-base) !important;
  }

  .v-pagination__item {
    background-color: #474747 !important;
    color: var(--v-newMobilePrimary-base) !important;
    &.v-pagination__item--active {
      background-color: var(--v-newMobilePrimary-base) !important;
      color: black !important;
    }
  }
  .v-pagination__item.v-pagination__item--active {
    background-color: var(--v-newMobilePrimary-base) !important;
    color: black !important;
  }
}
@media (orientation: landscape) {
  .vip-timeline-wrapper {
    height: 35vh;
  }
  .mobile-vip-header {
    height: 60px !important;
  }

  .theme--light.v-timeline::before {
    left: calc(50% - 25px) !important;
  }
  .v-timeline::after {
    left: calc(50% - 25px) !important;
  }
}

$timelineItemHeight_599: 55px;

@media (max-width: 599px) {
  .vip-card {
    font-size: 12px;

    .vip-progress-card {
      background-color: #1c1c1c;
      border: 1px solid white;
      border-radius: 20px;

      .vip-progress-status-title {
        background-image: linear-gradient(to left, #fddd04, #fdb504);
        padding: 1px 4px;
      }
    }

    .icon-size {
      height: 3.5em;
    }

    .vip-process-bar-icon {
      border: 8px solid #262626;
      z-index: 1;
    }

    .vip-progress-bar {
      background-color: #d9d9d9 !important;
      border-radius: 20px;
      margin-top: 8px;

      .v-progress-linear__background {
        background-color: #d9d9d9 !important;
        border-color: #d9d9d9 !important;
        opacity: 1 !important;
      }

      .v-progress-linear__determinate {
        background-color: #fd8839 !important;
      }
    }

    .v-btn.dialog-button {
      width: inherit !important;
      height: auto !important;
      font-size: 12px !important;
    }

    .v-timeline-item__opposite {
      padding-right: 8px;
    }
    .v-timeline-item {
      align-items: center;
      padding-bottom: 30px !important;
    }

    .theme--light.v-timeline::before {
      background-color: var(--v-newMobilePrimary-base);
      left: calc(50% - 15px) !important;
    }
    .v-timeline::after {
      left: calc(50% - 15px) !important;
    }

    .v-timeline-item__body {
      padding-left: 15px;
    }
    .v-timeline-item__dot {
      width: 145px;
      .v-timeline-item__inner-dot {
        width: inherit;
        .prizename-card {
          width: inherit;
          height: 44px;
        }
      }
    }
    .prizeImg.v-card {
      height: $timelineItemHeight_599;
      .icon-size {
        height: 2.6rem;
      }
      .prizeIndex-span {
        font-size: 0.7rem;
      }
    }
    .claim-btn {
      height: 44px !important;
      width: 90px !important;
    }
  }
}

.mobile-vip-progress-bar-text {
  color: #acacac;
  > div {
    display: flex;
    justify-content: space-between;
  }
}
@media (max-width: 499px) {
  .vip-progress-card {
    .mobile-logged-details {
      .mobile-logged-level {
        flex: 0 0 25.6666666667% !important;
        max-width: 25.666667% !important;
      }
    }
  }

  .vip-card {
    .betting-pass-summary-table {
      .betting-pass-prizes-row {
        .mobile-prize-card {
          min-width: 31dvw;
          .betting-pass-reward-container {
            height: 115px;
            justify-content: space-evenly;
            .betting-pass-reward-level-text,
            .betting-pass-reward-text {
              font-size: 0.8rem;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 399px) {
  .vip-card {
    .betting-pass-summary-table {
      .betting-pass-prizes-row {
        .mobile-prize-card {
          min-width: 35dvw;
          .betting-pass-reward-container {
            //height: 145px;
            .betting-pass-reward-img {
            }
          }
        }
      }
    }
  }
}
</style>
